import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

const CoingeckoIcon: React.FC<SvgProps> = ({ width = 15, height = 15, ...rest }) => (
  <Svg width={width} height={height} {...rest}>
    <G transform="translate(-5.6 -4.211)">
      <Path
        d="M36.47,27.012a7.064,7.064,0,1,1-7.1-7.033A7.064,7.064,0,0,1,36.47,27.012Z"
        transform="translate(-16.741 -15.768)"
        fill="#8dc63f"
      />
      <G transform="translate(6.484 5.093)">
        <Path
          id="Path_3602"
          d="M41.854,33.264a6.182,6.182,0,1,1-6.21-6.135A6.172,6.172,0,0,1,41.854,33.264Z"
          transform="translate(-29.491 -27.129)"
          fill="#f9e988"
        />
        <Path
          id="Path_3603"
          d="M118.85,32.126a3.391,3.391,0,0,1,1.188,0,3.623,3.623,0,0,1,1.135.379,6.5,6.5,0,0,1,.96.7c.3.247.605.5.892.772a4.515,4.515,0,0,1,.761.916,5.19,5.19,0,0,1,.533,1.071,4.852,4.852,0,0,1,.219,2.343H124.5a10.966,10.966,0,0,0-.579-2.2,8.621,8.621,0,0,0-.454-1.028,10.222,10.222,0,0,0-.6-.962,3.506,3.506,0,0,0-.807-.812,4.7,4.7,0,0,0-1.023-.5c-.349-.137-.7-.273-1.062-.378s-.734-.183-1.121-.258Z"
          transform="translate(-112.555 -31.726)"
          fill="#fff"
        />
        <Path
          d="M54.181,67.517c-.449-.13-.916-.313-1.385-.5a.943.943,0,0,0-.343-.444,1.671,1.671,0,0,0-1.385-.14,3.5,3.5,0,0,0-1.62-.05c-4.272,1.173-1.849,4.04-3.418,6.919a6.163,6.163,0,0,0,6.113,2.488,3.284,3.284,0,0,1,1.5-4.223C55.82,70.454,57.4,68.391,54.181,67.517Z"
          transform="translate(-44.865 -63.559)"
          fill="#8bc53f"
        />
        <Path
          d="M162.4,106.806a.259.259,0,1,1-.26-.256A.258.258,0,0,1,162.4,106.806Z"
          transform="translate(-152.555 -100.973)"
          fill="#fff"
        />
        <Path
          d="M117.56,66.754a6.492,6.492,0,0,1,1.728.586C119.048,66.637,118.231,66.546,117.56,66.754Z"
          transform="translate(-111.356 -63.88)"
          fill="#009345"
        />
        <Path
          d="M90.165,77.464a1.2,1.2,0,1,1-1.2-1.194A1.2,1.2,0,0,1,90.165,77.464Z"
          transform="translate(-83.665 -72.819)"
          fill="#fff"
        />
        <Path
          d="M94.542,82.328a.841.841,0,1,1-.841-.838A.84.84,0,0,1,94.542,82.328Z"
          transform="translate(-88.397 -77.673)"
          fill="#58595b"
        />
        <Path
          d="M54.776,110.707a5.988,5.988,0,0,1-3.633,1.194c-.731,0-.879-.772-1.362-.395a3.466,3.466,0,0,1-1.828.6,2.267,2.267,0,0,1-2.145-1.927,10.881,10.881,0,0,1-.748,3.834,6.057,6.057,0,0,0,6.181,2.56c-.259-1.8,1.322-3.57,2.213-4.474a11.589,11.589,0,0,0,1.321-1.4Z"
          transform="translate(-43.964 -104.348)"
          fill="#8bc53f"
        />
        <Path
          d="M122.847,118.125a4.352,4.352,0,0,1-1.023.654,6.515,6.515,0,0,1-1.148.417,3.608,3.608,0,0,1-1.225.14,1.678,1.678,0,0,1-1.121-.492l.013-.015a2.141,2.141,0,0,0,1.119.308,5.3,5.3,0,0,0,1.177-.1,6.445,6.445,0,0,0,1.144-.351,4.3,4.3,0,0,0,1.05-.579Z"
          transform="translate(-112.073 -111.721)"
          fill="#58595b"
        />
      </G>
    </G>
  </Svg>
)

export default CoingeckoIcon
